import { Box, HStack } from '@chakra-ui/react';
import React from 'react';
import type { ICalendarPlusSettings, IEvent } from '../../../../lib';

interface ISingleDayEventDotsProps {
	events: IEvent[];
	color: string;
	settings: ICalendarPlusSettings;
}
export const SingleDayEventDots = ({ events, color, settings }: ISingleDayEventDotsProps) => (
	<HStack spacing={1} position='absolute' top='5px'>
		{events.map((event, index) => (
			<Box
				key={index}
				width='6px'
				height='6px'
				borderRadius='50%'
				backgroundColor={event.color || settings.eventCategoryColors[event.eventType?.[0]]?.background || color}
			/>
		))}
	</HStack>
);
